import React,{useRef,useEffect} from 'react';
import { Box, Flex, Heading, Text, SimpleGrid, Button, Image, Icon, VStack } from '@chakra-ui/react';
import { FaAward } from "react-icons/fa6";
import { GiConsoleController } from "react-icons/gi";
import { Ri24HoursFill } from "react-icons/ri";
import { BiWorld } from "react-icons/bi";
import AboutsUsBG from "../../assets/AboutUS_sidepic.webp"
import VanillaTilt from "vanilla-tilt";
import { useNavigate } from 'react-router-dom';


function Aboutus() {
       const tiltRef = useRef(null);
        const navigate = useNavigate();
    
        useEffect(() => {
            if (tiltRef.current) {
                VanillaTilt.init(tiltRef.current, {
                    max: 10,
                    speed: 50,
                    glare: false,
                    "max-glare": 0,
                });
            }
    
            return () => {
                if (tiltRef.current?.vanillaTilt) {
                    tiltRef.current.vanillaTilt.destroy();
                }
            };
        }, []);
    return (
        <Box as="section" py="16" id="about" bg="customDarkBlue">
            <Box maxW="7xl" mx="auto" px={{ base: 4, md: 8 }}>
                <Flex direction={{ base: 'column', lg: 'row' }} align="center" gap={12}>
                    {/* Text Column */}
                    <Flex flex="1" direction="column" gap={6}  data-aos="fade-down">
                        <Box>
                            <Text fontSize="sm" color="blue.400" mb="2" fontWeight="bold">
                                About Dremotech
                            </Text>
                            <Heading as="h2" size="2xl" lineHeight="1.2">
                                <Text as="span" color="gray.400">Empowering Businesses</Text> since
                                <Text as="span" color="blue.400"> 2012</Text>
                            </Heading>
                        </Box>

                        <Text color="gray.600" fontSize="md">
                            At Dremotech, we build powerful websites, mobile apps, and digital solutions tailored to your business goals. With a commitment to innovation and client success, we’ve been helping brands grow globally for over a decade.
                        </Text>

                        {/* Info items */}
                        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6}>
                            <InfoItem icon={FaAward} title="Proven Expertise" text="Over 12 years of delivering top-tier digital solutions for businesses of all sizes." />
                            <InfoItem icon={GiConsoleController} title="Client-Centric Approach" text="Custom services designed around your unique goals and business challenges." />
                            <InfoItem icon={BiWorld} title="Global Presence" text="Serving clients worldwide with diverse projects across multiple industries." />
                            <InfoItem icon={Ri24HoursFill} title="24/7 Assistance" text="Dedicated support and technical guidance whenever you need it." />
                        </SimpleGrid>

                        <Button colorScheme="blue" size="lg" w="fit-content" borderRadius={10}
                            transition="all 0.3s ease"
                            border="2px solid transparent"
                            _hover={{
                                bg: 'transparent',
                                color: 'blue.300',
                                border: '2px solid',
                                borderColor: 'blue.400',
                            }}
                            as="a" 
                             onClick={() => navigate('/contact')}
                             data-aos="zoom-in"
                            >
                            Get in Touch
                        </Button>
                    </Flex>

                    {/* Image Column */}
                    <Flex flex="1" justify="center" align="center" ref={tiltRef} data-aos="flip-right">
                        <Image src={AboutsUsBG} alt="Dremotech Team" maxH="500px" />
                    </Flex>
                </Flex>
            </Box>
        </Box>
    );
}

function InfoItem({ icon, title, text }) {
    return (
        <Flex align="flex-start" gap={4}>
            <Icon as={icon} w={12} h={12} color="blue.400" />
            <VStack align="start" spacing={1}>
                <Heading as="h5" size="md">{title}</Heading>
                <Text fontSize="sm" color="gray.600">{text}</Text>
            </VStack>
        </Flex>
    );
}

export default Aboutus;
